import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { RolesConstants } from "../../../constants/roles";
import { useNavigate } from 'react-router-dom';
import useSignUp from "../../../hooks/useSignUp";
import Styles from "./join.module.css";
import RocketImg from './assets/images/rocket.png'
import ContractorImg from './assets/images/contractor.png'
import HomeownerImg from './assets/images/homeowner.png'

function Join(props) {
    const navigate = useNavigate();
    const signup = useSignUp();
    const data = props?.data;

    return (
        <div>
            <div className={Styles.actionCard}>
                <Row className='mt-3'>
                    <Col xs="3">
                        <img className='mw-100 ps-1 ms-3' src={RocketImg} alt='' />
                    </Col>
                    <Col xs="9" className='d-flex align-items-center'>
                        <span className='font-montserrat'>Simplifying the Homeowner-Contractor journey</span>
                    </Col>
                </Row>
                <Row className='mt-3 mx-0'>
                    <Col xs="12" className='mx-3'>
                        <span className='font-lora'>Use our <b>Al</b> to create design ideas with accurate local pricing for your project.</span>
                    </Col>
                </Row>
                <Row className='mt-3 px-4'>
                    <div className={`${Styles.buttonsContainer}`}>
                        <Row className='my-2'>
                            <Col xs="12" className='text-center'>
                                <span className='font-helvetica-world'>Join us</span>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col xs="6" className='text-center'>
                                <Button className={Styles.buttonHomeowner} onClick={() => {navigate(data?.homeownerStartUrl)}}>
                                    <img src={HomeownerImg} alt="" className="img-fluid" />
                                    I'm a Homeowner
                                </Button>
                            </Col>
                            <Col xs="6" className='text-center'>
                                <Button className={Styles.buttonContractor}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        signup.signupWithRole(RolesConstants.CONTRACTOR);
                                    }}
                                >
                                    <img src={ContractorImg} alt="" className="img-fluid" />
                                    I'm a Contractor
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Row>
                <Row className='mt-2 mb-4 px-4 text-center'>
                    <span className={Styles.signIn}>
                        <small>
                            Already have an account?
                            {' '}
                            <a href={data?.loginUrl} onClick={(e) => {
                                e.preventDefault();
                                signup.signIn();
                            }}>SIGN IN</a>
                        </small>
                    </span>
                </Row>
            </div>
        </div>
    );
}

export default Join;